/* Fahhar ile ayni kalp: SWishlist ikonlarini fahhar.com'daki ince cizgili kalple degistirir (fk-favori.js ile birebir). */
(function(){
  'use strict';
  var HEART = 'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z',
      OUTLINE = '<path d="' + HEART + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>',
      FILLED = '<path d="' + HEART + '" stroke="none"></path>',
      TARGETS = [{id: 'st_add_icon', html: OUTLINE}, {id: 'st_added_icon', html: FILLED}, {id: 'st_details_icon', html: OUTLINE}],
      applying = false;
  function apply(){
    if (applying) return false;
    applying = true;
    var found = 0;
    for (var i = 0; i < TARGETS.length; i++) {
      var symbol = document.getElementById(TARGETS[i].id);
      if (!symbol) continue;
      found++;
      var path = symbol.firstElementChild;
      if (!path || path.getAttribute('d') !== HEART) {
        symbol.setAttribute('viewBox', '0 0 24 24');
        symbol.innerHTML = TARGETS[i].html;
      }
    }
    applying = false;
    return found === TARGETS.length;
  }
  var watched = null, spriteObserver = new MutationObserver(function(){ apply(); });
  function hook(){
    var sprite = document.getElementById('st_wishlist_icons');
    if (!sprite) return false;
    apply();
    if (watched !== sprite) {
      spriteObserver.disconnect();
      spriteObserver.observe(sprite, {childList: true, subtree: true, attributes: true});
      watched = sprite;
    }
    return true;
  }
  hook();
  var tries = 0, timer = setInterval(function(){ hook(); if (++tries >= 30) clearInterval(timer); }, 2000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook);
  window.addEventListener('load', hook);
})();

(() => {
  'use strict';
  const turkish = document.documentElement.lang.toLowerCase().startsWith('tr');
  const setText = (selector, text) => document.querySelectorAll(selector).forEach(element => {
    if (element.textContent !== text) element.textContent = text;
  });
  const update = () => {
    document.querySelectorAll('product-card').forEach(card => {
      const figure = card.querySelector('.product-card__figure');
      const heart = card.querySelector('.st-wishlist-button[data-type="product-card"]');
      if (!figure || !heart) return;
      if (heart.parentElement !== figure) figure.append(heart);
      card.querySelectorAll('.fk-card-title-row').forEach(row => row.replaceWith(...row.childNodes));
    });
    if (!turkish) return;
    document.querySelectorAll('.st-wishlist-button').forEach(button => {
      const label = button.classList.contains('st-is-loading') ? 'Favoriler güncelleniyor' : button.classList.contains('st-is-added') ? 'Favorilerden çıkar' : 'Favorilere ekle';
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('title') !== label) button.setAttribute('title', label);
      const pressed = String(button.classList.contains('st-is-added'));
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    document.querySelectorAll('.st-wishlist-details-button').forEach(button => {
      if (button.getAttribute('aria-label') !== 'Favori listemi aç') button.setAttribute('aria-label', 'Favori listemi aç');
      if (button.getAttribute('title') !== 'Favori listemi aç') button.setAttribute('title', 'Favori listemi aç');
    });
    setText('.st-wishlist-details_title .st-h3', 'Favori listem');
    setText('.st-wishlist-details_empty p:first-child b', 'Favorilerinizi burada biriktirin');
    setText('.st-wishlist-details_empty p:nth-child(2)', 'Beğendiğiniz ürünlerin kalbine dokunun; hepsi burada sizi beklesin.');
    setText('.st-wishlist-save-your-wishlist a', 'Favorilerinizi hesabınıza kaydetmek için giriş yapın');
    // Favorilerim sayfası: fahhar.com ile aynı metinler.
    setText('.st-page-container > header > h2', 'Favori Listem');
    setText('.st-page_empty_heading b', 'Beğendiniz mi? Favori listenize ekleyin');
    setText('.st-page_empty_text', 'Favorileriniz, hepsi bir arada. İstek listesi özelliği ile hızlı ve kolay alışveriş yapın.');
    setText('.st-page_empty_actions .st-atc-button', 'Alışverişe Başla');
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  update();
})();
